import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ContactDetails from '../ContactDetails/PropertyContactDetails'
import { AnimationOnScroll } from 'react-animation-on-scroll';
import PlanOverview from '../PlanOverview/PropertyDetailsOverview'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import cardImg from "../../images/id-img.png"
import '../PlanData/PlanData.scss'
import './PropertyContent.scss'
import { Link } from 'gatsby'
import HolidayContactDetails from '../ContactDetails/HolidayContactDetails';

const PropertyContent = (props) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [scroll, setScroll] = useState(false)

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 500)
    })
  }, [])

  const propertyImages = props?.images;
  var propertyLightImages = propertyImages && propertyImages.map(img => img.url);

  const navLists = [
    {
      name: "overview",
      slug: "property-overview"
    },
    {
      name: "gallery",
      slug: "gallery"
    },
    {
      name: "payment plan",
      slug: "payment-plan"
    },
    
  ];

  if(props.latitude && props.longitude){
    navLists.push({
      name: "location",
      slug: "property-location"
    })
  }

  let isShortLets = props.department === "short-lettings"

  const targetLocation = (item) => {
    if (item === "gallery") {
      setIsOpen(true);
    } else {
      const elementRef = document.getElementById(item);
      if (elementRef) {
        // elementRef.scrollIntoView() 
        var headerOffset = 140;
        var elementPosition = elementRef.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
        window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
        });
      }
    } 
  }
  return (
    <section className='plan-data'>
      {props.offPlan &&
        <div className='page-nav'>
          <Container>
            <Row>
              <Col>
                <ul>
                  {
                    navLists.map((item, index) => {
                      return <li className={item.name == activeTab && "active"}>
                        <div className="nav-links" key={index}
                          onClick={() => {
                            setActiveTab(item.name)
                            targetLocation(item.slug)
                          }}
                        >{item.name}</div>
                      </li>
                    })
                  }
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      }

      <div className='overview-wrapper'>
        <Container>
          <Row>
            <Col>
              <div className='d-xl-flex justify-content-between'>
                <div className='overview-ltl'>
                  <AnimationOnScroll animateIn="animate__fadeIn" animateOnce={true}>
                    <PlanOverview {...props} />
                  </AnimationOnScroll>
                </div>
                <div className={`overview-rtl ${isShortLets ? "short-lets" : ""}`}>
                  <div className={`contact-box-sidebar position-sticky ${scroll ? "scrolled" : ""}`}>
                    <AnimationOnScroll animateIn="animate__fadeIn" animateOnce={true}>
                      <div className="contact-box d-none d-xl-block">
                          {props.department === "residential" ?
                            <ContactDetails {...props}  /> :
                            props.department === "short-lettings" ?
                            <HolidayContactDetails {...props} /> :
                          ""}
                      </div>
                    </AnimationOnScroll>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div >
      {/* Property image lightbox */}
      {isOpen && (
        <Lightbox
          mainSrc={propertyLightImages[photoIndex]}
          nextSrc={propertyLightImages[(photoIndex + 1) % propertyLightImages.length]}
          prevSrc={propertyLightImages[(photoIndex + propertyLightImages.length - 1) % propertyLightImages.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + propertyLightImages.length - 1) % propertyLightImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % propertyLightImages.length)
          }
        />
      )}
      {/* Property image lightbox */}
    </section >
  )
}

export default PropertyContent